module.exports = __webpack_public_path__ + "img/approve.1506872a.gif";